
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M10.8 3.89994L4.8 8.39994C4.3 8.77994 4 9.36994 4 9.99994V18.9999C4 20.0999 4.9 20.9999 6 20.9999H18C19.1 20.9999 20 20.0999 20 18.9999V9.99994C20 9.36994 19.7 8.77994 19.2 8.39994L13.2 3.89994C12.49 3.36994 11.51 3.36994 10.8 3.89994ZM12.5 12.4999C12.5 13.3299 11.83 13.9999 11 13.9999V17.4999C11 17.7799 10.78 17.9999 10.5 17.9999C10.22 17.9999 10 17.7799 10 17.4999V13.9999C9.17 13.9999 8.5 13.3299 8.5 12.4999V9.99994C8.5 9.71994 8.72 9.49994 9 9.49994C9.28 9.49994 9.5 9.71994 9.5 9.99994V12.4999H10V9.99994C10 9.71994 10.22 9.49994 10.5 9.49994C10.78 9.49994 11 9.71994 11 9.99994V12.4999H11.5V9.99994C11.5 9.71994 11.72 9.49994 12 9.49994C12.28 9.49994 12.5 9.71994 12.5 9.99994V12.4999ZM14.5 17.9999C14.22 17.9999 14 17.7799 14 17.4999V14.4999H13.5C13.22 14.4999 13 14.2799 13 13.9999V11.4999C13 10.6199 13.57 9.86994 14.36 9.60994C14.67 9.49994 15 9.74994 15 10.0899V17.4999C15 17.7799 14.78 17.9999 14.5 17.9999Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-food-bank`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconFoodBank

    ```js
    <b-new-b-icon-food-bank />
    ```
</docs>


